// Müşteriye gönderilecek mesaj şablonları (WhatsApp bağlantısı olarak açılır — otomatik API gönderimi yoktur)
export const trackUrl = (token) => `${window.location.origin}/takip/${token}`;

export const waLink = (phone, text) => {
  let d = String(phone || "").replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (d.startsWith("0")) d = d.slice(1);
  if (d.length === 10) d = "90" + d;
  return `https://wa.me/${d}?text=${encodeURIComponent(text)}`;
};

export const TEMPLATES = {
  atandi: { label: "Usta atandı", build: (j, url, c) => `Merhaba ${first(j.customer_name)}, ${c || "ServisPlus"} servis talebiniz (${j.job_number}) için ustamız ${first(j.assigned_technician_name) || "ekibimiz"} görevlendirildi. İş durumunu buradan takip edebilirsiniz: ${url}` },
  yolda: { label: "Usta yolda", build: (j, url, c, eta) => `Merhaba ${first(j.customer_name)}, ustamız ${first(j.assigned_technician_name)} yola çıktı${eta ? `, yaklaşık ${eta} dakika içinde adresinizde olacak` : ""}. Canlı takip: ${url}` },
  bitti: { label: "İş tamamlandı + anket", build: (j, url, c) => `Merhaba ${first(j.customer_name)}, ${j.job_number} numaralı servis işleminiz tamamlandı. Hizmetimizi 1 dakikada puanlarsanız çok memnun oluruz: ${url}` },
  randevu: { label: "Randevu hatırlatma", build: (j, url, c) => `Merhaba ${first(j.customer_name)}, ${j.job_number} numaralı servis randevunuz için hatırlatma. Detaylar: ${url}` },
};
const first = (n) => (n || "").split(" ")[0];
